import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/utils';

const initialState = {
  labels: [],
  error: '',
  loading: false,
};

const getLabelsStart = (state) => {
  return updateObject(state, { loading: true });
};

const getLabelsSuccess = (state, action) => {
  return updateObject(state, { loading: false, labels: action.payload.labels });
};

const getLabelsFail = (state) => {
  return updateObject(state, { loading: false });
};

const createLabelStart = (state) => {
  return updateObject(state, { loading: true });
};

const createLabelSuccess = (state) => {
  return updateObject(state, {});
};

const createLabelFail = (state) => {
  return updateObject(state, { loading: false });
};

const updateLabelStart = (state) => {
  return updateObject(state, { loading: true });
};

const updateLabelSuccess = (state) => {
  return updateObject(state, {});
};

const updateLabelFail = (state) => {
  return updateObject(state, { loading: false });
};

const removeLabelStart = (state) => {
  return updateObject(state, { loading: true });
};

const removeLabelSuccess = (state) => {
  return updateObject(state, {});
};

const removeLabelFail = (state) => {
  return updateObject(state, { loading: false });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_LABELS_START:
      return getLabelsStart(state, action);
    case actionTypes.GET_LABELS_SUCCESS:
      return getLabelsSuccess(state, action);
    case actionTypes.GET_LABELS_FAIL:
      return getLabelsFail(state, action);

    case actionTypes.CREATE_LABEL_START:
      return createLabelStart(state, action);
    case actionTypes.CREATE_LABEL_SUCCESS:
      return createLabelSuccess(state, action);
    case actionTypes.CREATE_LABEL_FAIL:
      return createLabelFail(state, action);

    case actionTypes.UPDATE_LABEL_START:
      return updateLabelStart(state, action);
    case actionTypes.UPDATE_LABEL_SUCCESS:
      return updateLabelSuccess(state, action);
    case actionTypes.UPDATE_LABEL_FAIL:
      return updateLabelFail(state, action);

    case actionTypes.REMOVE_LABEL_START:
      return removeLabelStart(state, action);
    case actionTypes.REMOVE_LABEL_SUCCESS:
      return removeLabelSuccess(state, action);
    case actionTypes.REMOVE_LABEL_FAIL:
      return removeLabelFail(state, action);

    default:
      return state;
  }
};

export default reducer;
